<template>
    <section class="section-padding section-bg" id="section_payment_plans">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2 class="mb-4">{{ $t('links.paymentPlans') }}</h2>
                    <iframe
                        src="/payment-plans.html"
                        frameborder="0"
                        width="100%"
                        :style="{ height: iframeHeight + 'px' }"
                        @load="resizeIframe"
                        ref="cherryIframe"
                    ></iframe>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ref } from 'vue';

export default {
    name: 'PaymentPlansPage',
    setup() {
        const iframeHeight = ref(2000);
        const cherryIframe = ref(null);

        const resizeIframe = () => {
            try {
                const iframe = cherryIframe.value;
                if (iframe && iframe.contentWindow && iframe.contentWindow.document.body) {
                    iframeHeight.value = iframe.contentWindow.document.body.scrollHeight;
                }
            } catch (e) {
                // Cross-origin fallback — keep default height
            }
        };

        return {
            iframeHeight,
            cherryIframe,
            resizeIframe
        };
    }
}
</script>
